export default function install (Vue, options) {
  /**
   * Page data utilities
   */
  Vue.prototype.$page = {
    /**
     * Get page file according to route path
     * @param {String} path
     * @return {Promise}
     */
    get (path) {
      return new Promise((resolve, reject) => {
        path = path.replace(/^\/|\/$/g, '')

        // If any segment starts with a _, reject
        path.split('/').forEach(segment => {
          if (segment.charAt(0) === '_') reject()
        })

        // Add a slash for non-root paths
        if (path !== '') path += '/'

        import('pages/' + path + 'index.md')
          .then(page => {
            page.path = path.replace(/\/$/, '')
            resolve(splitExcerpt(page))
          })
          .catch(reject)
      })
    }
  }

  /**
   * Global mixin
   */
  Vue.mixin({
    computed: {
      /**
       * Add a global computed property 'page' to reference the current page.
       * @return {Object}
       */
      page () { return this.$store.state.currentPage }
    }
  })
}

/**
 * Split page body by <!-- more --> tag
 * @param  {Object} page
 * @return {null}
 */
function splitExcerpt (page) {
  const parts = page.body.split('<!-- more -->')
  if (parts.length < 2) return page
  page.excerpt = parts[0]
  page.body = parts[0] + parts[1]
  return page
}



// WEBPACK FOOTER //
// ./app/src/plugins/page.js